/*
 * @File
 * @Author Ngatia Frankline <fngatia@gmail.com>
 * @Created 1/18/23, 6:24 PM.
 * @Bincrud Copyright (c) 2023 All rights reserved.
 */

import '../assets/bootstrap'
import '../assets/scss/main.scss'
import '../assets/js/main'

console.log('theme assets 1 2 3')